import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const dummyData = [
    { id: 1, merchant: 'ABC Store', customer: 'John Doe', gateway: 'JazzCash', actualAmount: 1000, debit: 100, pay: 900, source: 'App', purpose: 'Payment', commission: 10, salesTax: 5, invoiceId: 'INV-001', status: 'Completed' },
    { id: 2, merchant: 'XYZ Mart', customer: 'Jane Smith', gateway: 'EasyPaisa', actualAmount: 2000, debit: 200, pay: 1800, source: 'Web', purpose: 'Refund', commission: 20, salesTax: 10, invoiceId: 'INV-002', status: 'Pending' },
    { id: 3, merchant: 'Super Shop', customer: 'Alice Brown', gateway: 'UnionPay', actualAmount: 1500, debit: 150, pay: 1350, source: 'App', purpose: 'Payment', commission: 15, salesTax: 7, invoiceId: 'INV-003', status: 'Completed' },
    { id: 4, merchant: 'Mega Store', customer: 'Bob White', gateway: 'Bank Card', actualAmount: 2500, debit: 250, pay: 2250, source: 'Web', purpose: 'Payment', commission: 25, salesTax: 12, invoiceId: 'INV-004', status: 'Failed' }
];

const CollectionLedger = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState(dummyData);

    const filterData = () => {
        let filtered = dummyData;
        if (startDate) {
            filtered = filtered.filter((row) => new Date(row.createdDate) >= new Date(startDate));
        }
        if (endDate) {
            filtered = filtered.filter((row) => new Date(row.createdDate) <= new Date(endDate));
        }
        setData(filtered);
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Collection Ledger</h3>
                <div className="flex gap-2">
                    <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} placeholder="Start Date" dateFormat="yy-mm-dd" showIcon />
                    <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} placeholder="End Date" dateFormat="yy-mm-dd" showIcon />
                    {/* <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" /> */}
                </div>
            </div>
            <DataTable value={data} paginator rows={5} className="p-datatable-sm">
                <Column header="SrNo" body={(rowData, options) => options.rowIndex + 1} style={{ width: '60px' }} />
                <Column field="merchant" header="Merchant Name" />
                <Column field="customer" header="Customer Name" />
                <Column field="gateway" header="Gateway" />
                <Column field="actualAmount" header="Actual Amount" />
                <Column field="debit" header="Debit" />
                <Column field="pay" header="Pay" />
                <Column field="source" header="Source" />
                <Column field="purpose" header="Purpose" />
                <Column field="commission" header="Commission" />
                <Column field="salesTax" header="Sales Tax" />
                <Column field="invoiceId" header="Invoice Id" />
                <Column field="status" header="Status" body={(rowData) => <span className={`badge ${rowData.status === 'Completed' ? 'bg-success' : rowData.status === 'Pending' ? 'bg-warning' : 'bg-secondary'}`}>{rowData.status}</span>} />
            </DataTable>
        </div>
    );
};

export default CollectionLedger;
